import { LichSuPhienModel, StatsCount, SumResult } from 'models/gameModel';

export const convertSumResult = (sumValue: number) => {
    if (sumValue === 0) return 4;
    else if (sumValue === 1) return 3;
    else if (sumValue === 2) return 2;
    else if (sumValue === 3) return 1;
    else if (sumValue === 4) return 0;
    return sumValue;
};

export const calcstats = (historyData: LichSuPhienModel[], statsCount: StatsCount) => {
    historyData.forEach((item) => {
        const result = item.result.reduce((acc, num) => acc + num) as SumResult;
        const converResult = convertSumResult(result);
        if (converResult === 0) {
            // 4 trắng => chẵn, num0, xỉu
            statsCount.chan = (statsCount.chan || 0) + 1;
            statsCount.num0 = (statsCount.num0 || 0) + 1;
            statsCount.xiu = (statsCount.xiu || 0) + 1;
        } else if (converResult === 1) {
            // 3 trắng => lẻ, num1, xỉu
            statsCount.le = (statsCount.le || 0) + 1;
            statsCount.num1 = (statsCount.num1 || 0) + 1;
            statsCount.xiu = (statsCount.xiu || 0) + 1;
        } else if (converResult === 2) {
            // 2 trắng - 2 đỏ => chẵn, num2,
            statsCount.chan = (statsCount.chan || 0) + 1;
            statsCount.num2 = (statsCount.num2 || 0) + 1;
        } else if (converResult === 3) {
            // 3 đỏ => lẻ, num3, tài
            statsCount.le = (statsCount.le || 0) + 1;
            statsCount.num3 = (statsCount.num3 || 0) + 1;
            statsCount.tai = (statsCount.tai || 0) + 1;
        } else if (converResult === 4) {
            // 3 trắng => chẵn, num4, tài
            statsCount.chan = (statsCount.chan || 0) + 1;
            statsCount.num4 = (statsCount.num4 || 0) + 1;
            statsCount.tai = (statsCount.tai || 0) + 1;
        }
    });
    return statsCount;
};

export const calcstatsTX = (historyData: LichSuPhienModel[], statsCount: StatsCount) => {
    historyData.forEach((item) => {
        const result = item.result.reduce((acc, num) => acc + num) as SumResult;
        const sumResult = convertSumResult(result);
        if (sumResult >= 4 && sumResult <= 10 && !checkBao3(item.result)) {
            statsCount.xiu = (statsCount.xiu || 0) + 1;
        }
        //tai
        if (sumResult >= 11 && sumResult <= 17 && !checkBao3(item.result)) {
            statsCount.tai = (statsCount.xiu || 0) + 1;
        }
        //chan
        if (sumResult % 2 === 0 && !checkBao3(item.result)) {
            statsCount.chan = (statsCount.xiu || 0) + 1;
        }
        //le
        if (sumResult % 2 === 1 && !checkBao3(item.result)) {
            statsCount.le = (statsCount.xiu || 0) + 1;
        }
    });
    return statsCount;
};

export const checkBao3 = (result: number[]) => {
    return result.every((item) => item === result[0]);
};

export const convertSecondToTime = (totalSeconds: number, isSecond?: boolean) => {
    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    if (isSecond) {
        return `${('0' + seconds).slice(-2)}`;
    }
    return `${('0' + hours).slice(-2)}:${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`;
};

export const converPlaceToText = (place: number, gameType: number) => {
    if (gameType === 5) {
        return placeToTextTX(place);
    } else {
        return placeToTextXD(place);
    }
};

const placeToTextXD = (place: number) => {
    let placeText = '';
    if (place === 1) {
        placeText = 'Chẵn';
    } else if (place === 2) {
        placeText = 'Lẻ';
    } else if (place === 3) {
        placeText = '3 Đỏ 1 Trắng';
    } else if (place === 4) {
        placeText = '3 Trắng 1 Đỏ';
    } else if (place === 5) {
        placeText = '4 Đỏ';
    } else if (place === 6) {
        placeText = '4 Trắng';
    } else if (place === 7) {
        placeText = '2 Đỏ 2 Trắng';
    } else if (place === 8) {
        placeText = 'Xỉu';
    } else if (place === 9) {
        placeText = 'Tài';
    } else if (place === 10) {
        placeText = 'Tứ Tử';
    }
    return placeText;
};

const placeToTextTX = (place: number) => {
    let placeText = '';

    if (place === 1) {
        placeText = 'Xỉu';
    } else if (place === 2) {
        placeText = 'Tài';
    } else if (place === 3) {
        placeText = 'Chẵn';
    } else if (place === 4) {
        placeText = 'Lẻ';
    } else if (place === 5) {
        placeText = 'Đơn 1';
    } else if (place === 6) {
        placeText = 'Đơn 2';
    } else if (place === 7) {
        placeText = 'Đơn 3';
    } else if (place === 8) {
        placeText = 'Đơn 4';
    } else if (place === 9) {
        placeText = 'Đơn 5';
    } else if (place === 10) {
        placeText = 'Đơn 6';
    } else if (place === 11) {
        placeText = 'Cặp 1';
    } else if (place === 12) {
        placeText = 'Cặp 2';
    } else if (place === 13) {
        placeText = 'Cặp 3';
    } else if (place === 14) {
        placeText = 'Cặp 4';
    } else if (place === 15) {
        placeText = 'Cặp 5';
    } else if (place === 16) {
        placeText = 'Cặp 6';
    } else if (place === 17) {
        placeText = 'Bộ ba bất kỳ';
    } else if (place === 18) {
        placeText = 'Bộ ba 1-1-1';
    } else if (place === 19) {
        placeText = 'Bộ ba 2-2-2';
    } else if (place === 20) {
        placeText = 'Bộ ba 3-3-3';
    } else if (place === 21) {
        placeText = 'Bộ ba 4-4-4';
    } else if (place === 22) {
        placeText = 'Bộ ba 5-5-5';
    } else if (place === 23) {
        placeText = 'Bộ ba 6-6-6';
    } else if (place === 24) {
        placeText = 'Tổng 4';
    } else if (place === 25) {
        placeText = 'Tổng 5';
    } else if (place === 26) {
        placeText = 'Tổng 6';
    } else if (place === 27) {
        placeText = 'Tổng 7';
    } else if (place === 28) {
        placeText = 'Tổng 8';
    } else if (place === 29) {
        placeText = 'Tổng 9';
    } else if (place === 30) {
        placeText = 'Tổng 10';
    } else if (place === 31) {
        placeText = 'Tổng 11';
    } else if (place === 32) {
        placeText = 'Tổng 12';
    } else if (place === 33) {
        placeText = 'Tổng 13';
    } else if (place === 34) {
        placeText = 'Tổng 14';
    } else if (place === 35) {
        placeText = 'Tổng 15';
    } else if (place === 36) {
        placeText = 'Tổng 16';
    } else if (place === 37) {
        placeText = 'Tổng 17';
    } else if (place === 38) {
        placeText = '1 và 2';
    } else if (place === 39) {
        placeText = '1 và 3';
    } else if (place === 40) {
        placeText = '1 và 4';
    } else if (place === 41) {
        placeText = '1 và 5';
    } else if (place === 42) {
        placeText = '1 và 6';
    } else if (place === 43) {
        placeText = '2 và 3';
    } else if (place === 44) {
        placeText = '2 và 4';
    } else if (place === 45) {
        placeText = '2 và 5';
    } else if (place === 46) {
        placeText = '2 và 6';
    } else if (place === 47) {
        placeText = '3 và 4';
    } else if (place === 48) {
        placeText = '3 và 5';
    } else if (place === 49) {
        placeText = '3 và 6';
    } else if (place === 50) {
        placeText = '4 và 5';
    } else if (place === 51) {
        placeText = '4 và 6';
    } else if (place === 52) {
        placeText = '5 và 6';
    }
    return placeText;
};
